var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTiktok2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 10,
    fill: "url(#paint0_linear_5830_7714)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5830_7714)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.55137 9.30563C7.20116 9.39938 6.04199 10.3617 6.04199 11.8365C6.04199 13.2385 7.16553 14.375 8.55137 14.375C9.9372 14.375 11.061 13.2385 11.061 11.8365L10.9885 8.67188C11.6191 9.15854 12.6264 9.45271 13.5585 9.49979C13.7251 9.50813 13.8851 9.4325 13.9241 9.27C13.9439 9.18729 13.9587 9.07958 13.9587 8.94229C13.9587 8.805 13.9441 8.69729 13.9241 8.61458C13.8851 8.45208 13.7249 8.38167 13.5587 8.365C12.2982 8.23896 11.1114 7.21917 10.9418 6.015C10.9201 5.86292 10.8349 5.72229 10.686 5.68354C10.5352 5.64452 10.3802 5.62484 10.2245 5.625C10.0686 5.62479 9.91332 5.64446 9.76241 5.68354C9.61387 5.72229 9.52512 5.86188 9.52158 6.01563L9.38783 11.8365C9.38783 12.3038 9.01345 12.6827 8.55137 12.6827C8.08928 12.6827 7.71491 12.3038 7.71491 11.8365C7.71491 11.3506 8.12116 11.0379 8.55137 10.9579",
    stroke: "white",
    strokeWidth: 0.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_5830_7714",
    x1: 0,
    y1: 10,
    x2: 20,
    y2: 10,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CC4645"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9A1D1C"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5830_7714"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(5 5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok2);
export default __webpack_public_path__ + "static/media/tiktok 2.fa5ae5dcab5f8cf6930d5e30ae2e498e.svg";
export { ForwardRef as ReactComponent };